const menu = ["Features", "Pricing", /* 'testimonials',  "faq" */];

let counter = 0;
function createData(name, url, offset) {
  counter += 1;
  return {
    id: counter,
    name,
    url,
    offset,
  };
}

export const getMenuList = function () {
  const menuList = [];
  menu.forEach(field => {
    menuList.push(createData(field, "#" + field.toLowerCase()));
  });
  return menuList;
};

export default menu;
